import { withRouter } from 'react-router-dom';
import CaseCard from './CaseCard';

export default withRouter(CaseCard);
